import { type RefObject, useEffect, useRef, useState } from 'react';

export const useOnScreen = (ref: RefObject<HTMLElement>): boolean => {
	const observerRef = useRef<IntersectionObserver | null>(null);
	const [isOnScreen, setIsOnScreen] = useState<boolean>(false);

	useEffect(() => {
		if (!observerRef.current) {
			observerRef.current = new IntersectionObserver(([entry]) => {
				setIsOnScreen(entry.isIntersecting);
			});
		}

		const element = ref.current;
		if (element && observerRef.current) {
			observerRef.current.observe(element);
		}

		return () => {
			if (observerRef.current && element) {
				observerRef.current.unobserve(element);
			}
		};
	}, [ref]);

	// Cleanup observer on unmount
	useEffect(() => {
		return () => {
			if (observerRef.current) {
				observerRef.current.disconnect();
			}
		};
	}, []);

	return isOnScreen;
};
